import { z } from "zod";

export const CreatePromoSchema = z.object({
  code: z
    .string()
    .min(1, "Code is required")
    .transform((val) => val.trim().toUpperCase()),

  discountType: z.enum(["percentage", "fixed"]),

  discountValue: z
    .union([z.string(), z.number()])
    .transform((val) => Number(val))
    .refine((val) => !isNaN(val) && val > 0, {
      message: "Discount must be a positive number",
    }),

  maxDiscount: z
    .union([z.string(), z.number()])
    .optional()
    .transform((val) => (val ? Number(val) : 500)),

  minOrderAmount: z
    .union([z.string(), z.number()])
    .transform((val) => (val ? Number(val) : 0)),

  usageLimit: z
    .union([z.string(), z.number()])
    .transform((val) => Number(val))
    .refine((val) => Number.isFinite(val) && val > 0, {
      message: "Usage limit must be a positive number",
    }),

  perUserLimit: z
    .union([z.string(), z.number()])
    .optional()
    .transform((val) => (val ? Number(val) : 1)),

  expiresAt: z
    .string()
    .transform((val) =>
      val ? new Date(val).toISOString() : null
    ),
}).superRefine((data, ctx) => {
  //  business rule: usageLimit must be greater than perUserLimit
  if (
    data.usageLimit !== null &&
    data.usageLimit !== undefined &&
    data.usageLimit <= data.perUserLimit
  ) {
    ctx.addIssue({
      code: "custom",
      message: "Usage limit must be greater than per user limit",
      path: ["usageLimit"],
    });
  }
});

export type CreatePromoInput = z.infer<typeof CreatePromoSchema>;